module.exports = () => {
  return [
    {
      name: 'ID',
      value: 'id',
    },
    {
      name: '磁贴组件名称',
      value: 'name',
    },
  ];
};
